import { useUsersQuery } from "@sso/apis/users";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectUserQuery } from "@sso/store/slices/user";

export const useGetUsersQuery = () => {
  const queryParams = useAppSelector(selectUserQuery);
  return useUsersQuery(queryParams);
};
